export const boardFinancialPaymentsTour = {
  key: "boardFinancialPayments",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-finpay-income"]',
      content: t("Tour_FinPay_Income"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-finpay-expense"]',
      content: t("Tour_FinPay_Expense"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-balance"]',
      content: t("Tour_FinPay_Balance"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-finpay-add"]',
      content: t("Tour_FinPay_Add"),
      placement: "bottom",
    },
  ],
};
